import request from '@/utils/request'

export function listPayFeeSub(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/feeSub.listPayFeeSub',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || 'Failed to get fee sub list'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

export function listFee(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/fee.listFee',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
        resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 拆分试算
export function computePayFeeSplit(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/feeSub.computePayFeeSplit',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 多笔拆分提交
export function splitPayFeeMulti(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/feeSub.splitPayFee',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}